import { Component, OnInit } from '@angular/core';
import { OrderService } from '@app/core';
import { Order } from '@core/model/order.model';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})
export class OrderComponent implements OnInit {
  orders: Order[];
  constructor(private orderService: OrderService) {}

  ngOnInit() {
    // this.lisdOrder();
  }
  lisdOrder() {
    this.orderService.getAll().subscribe(
      data => {
        this.orders = data;
        console.log(data);
      },
      error1 => {
        console.log(error1);
      }
    );
  }
}
